// Tile markup.  
var productCardMarkup = `<div id="shared-wishlist-list">
		<div class="swym-widget swym-products swym-products-grid" id="swym-widget-shared-{{hkey}}">
			<ul class="swym-products-loop">
				{{#productArray}}
				<li class="swym-product-grid-li">
					<div class="swym-product-grid-item">
						<div class="swym-product-grid-overlay"></div><a class="swym-product-grid-hyperlink" href="{{uri}}" title="{{title}}">
						<div class="swym-product-grid-meta"></div>
						<div class="swym-product-grid-image">
							<div class="swym-product-grid-image-placeholder">
								<span class="swym-v-align-outer"><span class="swym-v-align-inner"><img alt="{{title}}" itemprop="image" src="{{iu}}"></span></span>
							</div>
						</div>
						<div class="swym-product-grid-info">
							<span>{{title}}</span> <span></span>
						</div>
						<div class="swym-product-grid-price">
							<span><span class="swym-pr">{{cu}}{{pr}}</span></span>
						</div></a>
						<div class="swym-product-grid-actions"></div>
					</div>
				</li>
				{{/productArray}}
			</ul>
		</div> 
	</div>
	<style>
	 @media screen and (min-width: 800px) {
	   #swym-widget-shared-{{hkey}} .swym-product-grid-li {
	     width: 25%;
	   }
	   #swym-widget-shared-{{hkey}}.swym-products-grid .swym-product-grid-li:nth-child(4n+1) {
	     clear: left;
	   }
	 }
	 @media screen and (max-width: 800px) {
	   #swym-widget-shared-{{hkey}} .swym-product-grid-li {
	     width: 33.333333333333336%;
	   }
	   #swym-widget-shared-{{hkey}} .swym-product-grid-li:nth-child(3n+1) {
	     clear: left;
	   }
	 }
	 @media screen and (max-width: 570px) {
	   #swym-widget-shared-{{hkey}} .swym-product-grid-li {
	     width: 100%;
	   }
	   #swym-widget-shared-{{hkey}}.swym-products-grid .swym-product-grid-li:nth-child(1n+1) {
	     clear: left;
	   }
	 }
	</style>`;

function fetchSharedWishlistProducts() {
	//   Get the Hkey
	var userHkey = SwymUtils.getParameterByName("hkey");
	if (userHkey && userHkey.length > 0 && userHkey.trim() !== "") {
		_swat.sharedWlApi.fetch({
			params: {
				hkey: userHkey
			},
			scb: function(res) {
				console.log('Shared Res', res);
				if(res.querystr.email) {
					document.querySelector('#shared-title').textContent = `Wishlist From: ${res.querystr.email}`;
				}
				renderWishlistUI(res.queryres, userHkey);
			},
			fcb: function() {
				SwymUtils.error("Error fetching shared wishlisted Products", arguments);
				errorCallback(null);
			}
		});
	}
}
// Render the Products in the User Interface.
function renderWishlistUI(products, userHkey) {
	//fetch the container.
	var wishlistContentsContainer = document.getElementById("wishlist-items-container");
	//   format products if required
	var formattedWishlistedProducts = products.map(function(p) {
		p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
		return p;
	});
	// final shared products output.   
	var sharedProducts = {
		productArray: formattedWishlistedProducts,
		hkey: userHkey
	};
	//render the page using mustache.
	var productCardsMarkup = Mustache.render(productCardMarkup, sharedProducts);
	wishlistContentsContainer.innerHTML = productCardsMarkup;
};

function errorCallbackFn() {
	//   your error callback.
	console.log("error, rendering shared wishlisted products");
}
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(fetchSharedWishlistProducts);
